import { BulkActions as e } from "./primitive/bulk-actions.js";
import { jsx as t, jsxs as n } from "react/jsx-runtime";
//#region src/table/bulk-actions/bulk-actions-bar.tsx
var r = ({ open: r, onOpenChange: i, children: a, rootProps: o, portalProps: s, popupProps: c, closeProps: l }) => /* @__PURE__ */ t(e.Root, {
	open: r,
	onOpenChange: i,
	...o,
	children: /* @__PURE__ */ t(e.Portal, {
		...s,
		children: /* @__PURE__ */ n(e.Popup, {
			...c,
			children: [
				/* @__PURE__ */ t(e.Close, { ...l }),
				/* @__PURE__ */ t("span", { className: "ml-auto" }),
				a
			]
		})
	})
});
r.displayName = "BulkActionsBar";
//#endregion
export { r as BulkActionsBar };
